import React, { useContext } from "react";
import { SitesProvider } from "./SitesContext";
import { DetectionProductProvider } from "./DetectionProductContext";
import { SharedDataProvider } from "./SharedDataContext";
import { AuthContext } from "./AuthContext";
import { RailroadOperatorProvider } from "./RailroadOperatorContext";

const AppProviders = ({ children }) => {
  const { member, token } = useContext(AuthContext);

  return (
    <SitesProvider member={member} token={token}>
      <DetectionProductProvider  member={member} token={token}>
        <RailroadOperatorProvider token={token}>
          <SharedDataProvider member={member} token={token}>
            {children} {/* Render children here */}
          </SharedDataProvider>
        </RailroadOperatorProvider>
      </DetectionProductProvider>
    </SitesProvider>
  );
};

export default AppProviders;
